export default {
  en: {
    language: {
      name: 'Language',
      title: 'Select Language',
      description: 'Select system language.',
    },
    room: {
      name: 'Room',
    },
    back: {
      name: 'Back',
    },
    channel: {
      name: 'Channel',
    },
    cast: {
      title: 'Cast',
      pairing: 'Scan the QR code with your phone to connect to the TV and start casting.',
      pairingNative: 'On your phone, open Google Cast or AirPlay and select this TV to start casting.',
      pairingNetwork: 'Scan the QR code to join the same WiFi network as the TV, then open Google Cast or AirPlay on your phone.',
      pairingScreenShare: 'Open Screen Share on your phone and select this TV.',
      castEntryHint: 'Blue button: open screen sharing on the TV',
      castSettingsHint: 'Blue button: open the Google Cast settings of the TV',
      noApps: 'No cast apps configured.',
      wifi: 'WiFi',
      password: 'Password',
      unsupported: 'Casting is not supported on this TV.',
      hotspotStarting: 'Starting the WiFi hotspot of this TV …',
      hotspotDown: 'The WiFi hotspot of this TV is not active at the moment. Please contact the staff.',
      preparing: 'Preparing the connection …',
      waitingForPhone: 'Waiting for your phone …',
      phoneConnected: 'Phone connected',
      connectTitle: 'Connect your phone',
      continueHint: 'Once your phone is connected: press OK.',
      autoContinue: 'continuing in',
      stayHint: 'BACK: stay here and show the QR code',
      tilesBackHint: 'BACK: show the QR code to connect your phone',
      castTilesHint: 'Or cast from your phone: open the app (YouTube, Prime Video, Disney+ …), tap the cast icon and pick this TV.',
      clearHint: 'Red button: delete your sign-in data from this TV',
      clearTitle: 'Delete sign-in data',
      clearText: 'Your sign-ins to the apps on this TV (Netflix, Spotify …) will be removed. This affects this TV only, not your account.',
      clearConfirm: 'Delete now',
      clearCancel: 'Cancel',
      clearBusy: 'Deleting …',
      clearDone: 'Your sign-in data has been removed from this TV.',
      clearRebootText: 'This TV can only remove the sign-in data while restarting. Restart now? It takes about a minute.',
      clearRebootNow: 'Restart now',
      clearRebootLater: 'Later',
      clearLater: 'The sign-in data will be removed the next time the TV is switched off and on again.',
      clearClose: 'OK',
      launching: '{app} is starting …',
      installing: 'Installing {app} on this TV …',
      installWait: 'This may take a moment.',
      unavailable: '{app} is currently not available on this TV.',
      installFailed: '{app} could not be installed and is currently not available on this TV.',
      unavailableHint: 'Please contact the reception.',
      unavailableKeys: 'OK: other apps · BACK: home screen',
    },
    epg: {
      title: 'TV Guide',
      loading: 'Loading programme data …',
      noData: 'No programme information',
      noDescription: 'No further information available.',
      running: 'on air',
      nowOnAir: 'Currently on this channel',
      hint: 'Arrows: navigate · OK: details · GREEN: back to now · BACK: exit',
      infoHint: 'LEFT/RIGHT: channel list ↔ text · UP/DOWN: switch channel or scroll · OK: watch · BACK: guide',
    },
    player: {
      hint: 'OK: play/pause · ◀◀ ▶▶: rewind/forward · ■: stop · LEFT/RIGHT: 15 s · BACK: exit',
    },
    dateISO: 'en-GB',
  },
  de: {
    language: {
      name: 'Sprache',
      title: 'Sprache auswählen',
      description: 'Wählen Sie die Systemsprache.',
    },
    room: {
      name: 'Zimmer',
    },
    back: {
      name: 'Zurück',
    },
    channel: {
      name: 'Kanal',
    },
    cast: {
      title: 'Cast',
      pairing: 'Scannen Sie den QR-Code mit Ihrem Smartphone, um sich mit dem TV zu verbinden und zu casten.',
      pairingNative: 'Öffnen Sie auf Ihrem Smartphone Google Cast oder AirPlay und wählen Sie diesen TV aus, um zu casten.',
      pairingNetwork: 'Scannen Sie den QR-Code, um in dasselbe WLAN wie der TV zu wechseln. Öffnen Sie danach Google Cast oder AirPlay auf Ihrem Smartphone.',
      pairingScreenShare: 'Öffnen Sie die Bildschirmübertragung auf Ihrem Smartphone und wählen Sie diesen TV aus.',
      castEntryHint: 'Blaue Taste: Bildschirmübertragung am TV öffnen',
      castSettingsHint: 'Blaue Taste: Google-Cast-Einstellungen des TV öffnen',
      noApps: 'Keine Cast-Apps konfiguriert.',
      wifi: 'WLAN',
      password: 'Passwort',
      unsupported: 'Casting wird auf diesem TV nicht unterstützt.',
      hotspotStarting: 'Der WLAN-Hotspot dieses Fernsehers wird gestartet …',
      hotspotDown: 'Der WLAN-Hotspot dieses Fernsehers ist zurzeit nicht aktiv. Bitte wenden Sie sich an das Personal.',
      preparing: 'Verbindung wird vorbereitet …',
      waitingForPhone: 'Warte auf die Verbindung des Smartphones …',
      phoneConnected: 'Smartphone verbunden',
      connectTitle: 'Smartphone verbinden',
      continueHint: 'Sobald Ihr Smartphone verbunden ist: OK drücken.',
      autoContinue: 'weiter in',
      stayHint: 'ZURÜCK: hier bleiben und QR-Code anzeigen',
      tilesBackHint: 'ZURÜCK: QR-Code zum Verbinden des Smartphones anzeigen',
      castTilesHint: 'Oder vom Smartphone casten: App öffnen (YouTube, Prime Video, Disney+ …), auf das Cast-Symbol tippen und diesen TV wählen.',
      clearHint: 'Rote Taste: Anmeldedaten von diesem Fernseher löschen',
      clearTitle: 'Anmeldedaten löschen',
      clearText: 'Ihre Anmeldungen in den Apps dieses Fernsehers (Netflix, Spotify …) werden entfernt. Das betrifft nur diesen Fernseher, nicht Ihr Konto.',
      clearConfirm: 'Jetzt löschen',
      clearCancel: 'Abbrechen',
      clearBusy: 'Wird gelöscht …',
      clearDone: 'Ihre Anmeldedaten wurden von diesem Fernseher entfernt.',
      clearRebootText: 'Dieser Fernseher kann die Anmeldedaten nur beim Neustart entfernen. Jetzt neu starten? Das dauert etwa eine Minute.',
      clearRebootNow: 'Jetzt neu starten',
      clearRebootLater: 'Später',
      clearLater: 'Die Anmeldedaten werden entfernt, sobald der Fernseher aus- und wieder eingeschaltet wird.',
      clearClose: 'OK',
      launching: '{app} wird gestartet …',
      installing: '{app} wird auf diesem Fernseher installiert …',
      installWait: 'Das kann einen Moment dauern.',
      unavailable: '{app} ist auf diesem Fernseher derzeit leider nicht verfügbar.',
      installFailed: '{app} konnte nicht installiert werden und ist auf diesem Fernseher derzeit nicht verfügbar.',
      unavailableHint: 'Bitte wenden Sie sich an die Rezeption.',
      unavailableKeys: 'OK: weitere Apps · ZURÜCK: Startseite',
    },
    epg: {
      title: 'TV-Programm',
      loading: 'Programmdaten werden geladen …',
      noData: 'Keine Programminformationen',
      noDescription: 'Keine weiteren Informationen verfügbar.',
      running: 'läuft',
      nowOnAir: 'Läuft gerade auf diesem Sender',
      hint: 'Pfeile: navigieren · OK: Details · GRÜN: zurück zu jetzt · ZURÜCK: verlassen',
      infoHint: 'LINKS/RECHTS: Senderliste ↔ Text · HOCH/RUNTER: Sender wechseln oder blättern · OK: ansehen · ZURÜCK: Übersicht',
    },
    player: {
      hint: 'OK: Wiedergabe/Pause · ◀◀ ▶▶: spulen · ■: Stopp · LINKS/RECHTS: 15 s · ZURÜCK: verlassen',
    },
    dateISO: 'de-DE',
  },
  ch_de: {
    language: {
      name: 'Sprache',
      title: 'Sprache auswählen',
      description: 'Wählen Sie die Systemsprache.',
    },
    room: {
      name: 'Zimmer',
    },
    back: {
      name: 'Zurück',
    },
    channel: {
      name: 'Kanal',
    },
    // Schweizer Rechtschreibung: kein ß, stattdessen ss.
    cast: {
      title: 'Cast',
      pairing: 'Scannen Sie den QR-Code mit Ihrem Smartphone, um sich mit dem TV zu verbinden und zu casten.',
      pairingNative: 'Öffnen Sie auf Ihrem Smartphone Google Cast oder AirPlay und wählen Sie diesen TV aus, um zu casten.',
      pairingNetwork: 'Scannen Sie den QR-Code, um in dasselbe WLAN wie der TV zu wechseln. Öffnen Sie danach Google Cast oder AirPlay auf Ihrem Smartphone.',
      pairingScreenShare: 'Öffnen Sie die Bildschirmübertragung auf Ihrem Smartphone und wählen Sie diesen TV aus.',
      castEntryHint: 'Blaue Taste: Bildschirmübertragung am TV öffnen',
      castSettingsHint: 'Blaue Taste: Google-Cast-Einstellungen des TV öffnen',
      noApps: 'Keine Cast-Apps konfiguriert.',
      wifi: 'WLAN',
      password: 'Passwort',
      unsupported: 'Casting wird auf diesem TV nicht unterstützt.',
      hotspotStarting: 'Der WLAN-Hotspot dieses Fernsehers wird gestartet …',
      hotspotDown: 'Der WLAN-Hotspot dieses Fernsehers ist zurzeit nicht aktiv. Bitte wenden Sie sich an das Personal.',
      preparing: 'Verbindung wird vorbereitet …',
      waitingForPhone: 'Warte auf die Verbindung des Smartphones …',
      phoneConnected: 'Smartphone verbunden',
      connectTitle: 'Smartphone verbinden',
      continueHint: 'Sobald Ihr Smartphone verbunden ist: OK drücken.',
      autoContinue: 'weiter in',
      stayHint: 'ZURÜCK: hier bleiben und QR-Code anzeigen',
      tilesBackHint: 'ZURÜCK: QR-Code zum Verbinden des Smartphones anzeigen',
      castTilesHint: 'Oder vom Smartphone casten: App öffnen (YouTube, Prime Video, Disney+ …), auf das Cast-Symbol tippen und diesen TV wählen.',
      clearHint: 'Rote Taste: Anmeldedaten von diesem Fernseher löschen',
      clearTitle: 'Anmeldedaten löschen',
      clearText: 'Ihre Anmeldungen in den Apps dieses Fernsehers (Netflix, Spotify …) werden entfernt. Das betrifft nur diesen Fernseher, nicht Ihr Konto.',
      clearConfirm: 'Jetzt löschen',
      clearCancel: 'Abbrechen',
      clearBusy: 'Wird gelöscht …',
      clearDone: 'Ihre Anmeldedaten wurden von diesem Fernseher entfernt.',
      clearRebootText: 'Dieser Fernseher kann die Anmeldedaten nur beim Neustart entfernen. Jetzt neu starten? Das dauert etwa eine Minute.',
      clearRebootNow: 'Jetzt neu starten',
      clearRebootLater: 'Später',
      clearLater: 'Die Anmeldedaten werden entfernt, sobald der Fernseher aus- und wieder eingeschaltet wird.',
      clearClose: 'OK',
      launching: '{app} wird gestartet …',
      installing: '{app} wird auf diesem Fernseher installiert …',
      installWait: 'Das kann einen Moment dauern.',
      unavailable: '{app} ist auf diesem Fernseher derzeit leider nicht verfügbar.',
      installFailed: '{app} konnte nicht installiert werden und ist auf diesem Fernseher derzeit nicht verfügbar.',
      unavailableHint: 'Bitte wenden Sie sich an die Rezeption.',
      unavailableKeys: 'OK: weitere Apps · ZURÜCK: Startseite',
    },
    epg: {
      title: 'TV-Programm',
      loading: 'Programmdaten werden geladen …',
      noData: 'Keine Programminformationen',
      noDescription: 'Keine weiteren Informationen verfügbar.',
      running: 'läuft',
      nowOnAir: 'Läuft gerade auf diesem Sender',
      hint: 'Pfeile: navigieren · OK: Details · GRÜN: zurück zu jetzt · ZURÜCK: verlassen',
      infoHint: 'LINKS/RECHTS: Senderliste ↔ Text · HOCH/RUNTER: Sender wechseln oder blättern · OK: ansehen · ZURÜCK: Übersicht',
    },
    dateISO: 'de-CH',
  },
  ch_fr: {
    language: {
      name: 'Langue',
      title: 'Sélection de la langue',
      description: 'Sélectionner la langue du système.',
    },
    room: {
      name: 'Salle',
    },
    back: {
      name: 'Retour',
    },
    channel: {
      name: 'Chaîne',
    },
    cast: {
      title: 'Cast',
      pairing: 'Scannez le code QR avec votre téléphone pour vous connecter au téléviseur et diffuser.',
      pairingNative: 'Sur votre téléphone, ouvrez Google Cast ou AirPlay et sélectionnez ce téléviseur.',
      pairingNetwork: 'Scannez le code QR pour rejoindre le même réseau Wi-Fi que le téléviseur, puis ouvrez Google Cast ou AirPlay sur votre téléphone.',
      pairingScreenShare: 'Ouvrez le partage d’écran sur votre téléphone et sélectionnez ce téléviseur.',
      castEntryHint: 'Touche bleue : ouvrir le partage d’écran sur le téléviseur',
      castSettingsHint: 'Touche bleue : ouvrir les réglages Google Cast du téléviseur',
      noApps: 'Aucune application de diffusion configurée.',
      wifi: 'Wi-Fi',
      password: 'Mot de passe',
      unsupported: 'La diffusion n’est pas prise en charge sur ce téléviseur.',
      hotspotStarting: 'Démarrage du point d’accès WiFi de ce téléviseur …',
      hotspotDown: 'Le point d’accès WiFi de ce téléviseur n’est pas actif actuellement. Veuillez contacter le personnel.',
      preparing: 'Préparation de la connexion …',
      waitingForPhone: 'En attente de la connexion du téléphone …',
      phoneConnected: 'Téléphone connecté',
      connectTitle: 'Connecter le téléphone',
      continueHint: 'Dès que votre téléphone est connecté : appuyez sur OK.',
      autoContinue: 'suite dans',
      stayHint: 'RETOUR : rester ici et afficher le code QR',
      tilesBackHint: 'RETOUR : afficher le code QR pour connecter le téléphone',
      castTilesHint: 'Ou depuis votre téléphone : ouvrez l’application (YouTube, Prime Video, Disney+ …), touchez l’icône Cast et choisissez ce téléviseur.',
      clearHint: 'Touche rouge : supprimer vos données de connexion de ce téléviseur',
      clearTitle: 'Supprimer les données de connexion',
      clearText: 'Vos connexions aux applications de ce téléviseur (Netflix, Spotify …) seront supprimées. Cela ne concerne que ce téléviseur, pas votre compte.',
      clearConfirm: 'Supprimer maintenant',
      clearCancel: 'Annuler',
      clearBusy: 'Suppression …',
      clearDone: 'Vos données de connexion ont été supprimées de ce téléviseur.',
      clearRebootText: 'Ce téléviseur ne peut supprimer les données de connexion qu’au redémarrage. Redémarrer maintenant ? Cela prend environ une minute.',
      clearRebootNow: 'Redémarrer maintenant',
      clearRebootLater: 'Plus tard',
      clearLater: 'Les données de connexion seront supprimées lors du prochain arrêt et rallumage du téléviseur.',
      clearClose: 'OK',
      launching: '{app} démarre …',
      installing: 'Installation de {app} sur ce téléviseur …',
      installWait: 'Cela peut prendre un moment.',
      unavailable: '{app} n\'est actuellement pas disponible sur ce téléviseur.',
      installFailed: '{app} n\'a pas pu être installé et n\'est actuellement pas disponible sur ce téléviseur.',
      unavailableHint: 'Veuillez vous adresser à la réception.',
      unavailableKeys: 'OK : autres applications · RETOUR : accueil',
    },
    epg: {
      title: 'Programme TV',
      loading: 'Chargement du programme …',
      noData: 'Aucune information sur le programme',
      noDescription: 'Aucune information complémentaire disponible.',
      running: 'en cours',
      nowOnAir: 'Actuellement sur cette chaîne',
      hint: 'Flèches : naviguer · OK : détails · VERT : revenir à maintenant · RETOUR : quitter',
      infoHint: 'GAUCHE/DROITE : liste ↔ texte · HAUT/BAS : changer de chaîne ou défiler · OK : regarder · RETOUR : programme',
    },
    dateISO: 'fr-CH',
  },
  ch_it: {
    language: {
      name: 'Lingua',
      title: 'Selezionare la lingua',
      description: 'Selezionare la lingua del sistema.',
    },
    room: {
      name: 'Camera',
    },
    back: {
      name: 'Indietro',
    },
    channel: {
      name: 'Canale',
    },
    cast: {
      title: 'Cast',
      pairing: 'Scansiona il codice QR con il telefono per collegarti al televisore e trasmettere.',
      pairingNative: 'Sul telefono apri Google Cast o AirPlay e seleziona questo televisore.',
      pairingNetwork: 'Scansiona il codice QR per collegarti alla stessa rete Wi-Fi del televisore, poi apri Google Cast o AirPlay sul telefono.',
      pairingScreenShare: 'Apri la condivisione dello schermo sul telefono e seleziona questo televisore.',
      castEntryHint: 'Tasto blu: apri la condivisione dello schermo sul televisore',
      castSettingsHint: 'Tasto blu: apri le impostazioni Google Cast del televisore',
      noApps: 'Nessuna app di trasmissione configurata.',
      wifi: 'Wi-Fi',
      password: 'Password',
      unsupported: 'La trasmissione non è supportata su questo televisore.',
      hotspotStarting: 'Avvio dell’hotspot WiFi di questo televisore …',
      hotspotDown: 'L’hotspot WiFi di questo televisore non è attivo al momento. Si rivolga al personale.',
      preparing: 'Preparazione della connessione …',
      waitingForPhone: 'In attesa della connessione del telefono …',
      phoneConnected: 'Telefono connesso',
      connectTitle: 'Collega il telefono',
      continueHint: 'Quando il telefono è collegato: premere OK.',
      autoContinue: 'avanti tra',
      stayHint: 'INDIETRO: restare qui e mostrare il codice QR',
      tilesBackHint: 'INDIETRO: mostrare il codice QR per collegare il telefono',
      castTilesHint: 'Oppure dal telefono: aprire l’app (YouTube, Prime Video, Disney+ …), toccare l’icona Cast e scegliere questo TV.',
      clearHint: 'Tasto rosso: eliminare i dati di accesso da questo televisore',
      clearTitle: 'Eliminare i dati di accesso',
      clearText: 'I tuoi accessi alle app di questo televisore (Netflix, Spotify …) verranno rimossi. Riguarda solo questo televisore, non il tuo account.',
      clearConfirm: 'Elimina ora',
      clearCancel: 'Annulla',
      clearBusy: 'Eliminazione …',
      clearDone: 'I tuoi dati di accesso sono stati rimossi da questo televisore.',
      clearRebootText: 'Questo televisore può rimuovere i dati di accesso solo al riavvio. Riavviare ora? Richiede circa un minuto.',
      clearRebootNow: 'Riavvia ora',
      clearRebootLater: 'Più tardi',
      clearLater: 'I dati di accesso verranno rimossi al prossimo spegnimento e riaccensione del televisore.',
      clearClose: 'OK',
      launching: 'Avvio di {app} …',
      installing: 'Installazione di {app} su questo televisore …',
      installWait: 'Potrebbe richiedere qualche istante.',
      unavailable: '{app} al momento non è disponibile su questo televisore.',
      installFailed: 'Non è stato possibile installare {app}: al momento non è disponibile su questo televisore.',
      unavailableHint: 'Si prega di rivolgersi alla reception.',
      unavailableKeys: 'OK: altre app · INDIETRO: pagina iniziale',
    },
    epg: {
      title: 'Programmi TV',
      loading: 'Caricamento dei programmi …',
      noData: 'Nessuna informazione sul programma',
      noDescription: 'Nessuna ulteriore informazione disponibile.',
      running: 'in corso',
      nowOnAir: 'In onda ora su questo canale',
      hint: 'Frecce: naviga · OK: dettagli · VERDE: torna a ora · INDIETRO: esci',
      infoHint: 'SINISTRA/DESTRA: elenco ↔ testo · SU/GIÙ: cambia canale o scorri · OK: guarda · INDIETRO: programmi',
    },
    dateISO: 'it-CH',
  },
  fr: {
    language: {
      name: 'Langue',
      title: 'Sélection de la langue',
      description: 'Sélectionner la langue du système.',
    },
    room: {
      name: 'Salle',
    },
    back: {
      name: 'Retour',
    },
    channel: {
      name: 'Chaîne',
    },
    cast: {
      title: 'Cast',
      pairing: 'Scannez le code QR avec votre téléphone pour vous connecter au téléviseur et diffuser.',
      pairingNative: 'Sur votre téléphone, ouvrez Google Cast ou AirPlay et sélectionnez ce téléviseur.',
      pairingNetwork: 'Scannez le code QR pour rejoindre le même réseau Wi-Fi que le téléviseur, puis ouvrez Google Cast ou AirPlay sur votre téléphone.',
      pairingScreenShare: 'Ouvrez le partage d’écran sur votre téléphone et sélectionnez ce téléviseur.',
      castEntryHint: 'Touche bleue : ouvrir le partage d’écran sur le téléviseur',
      castSettingsHint: 'Touche bleue : ouvrir les réglages Google Cast du téléviseur',
      noApps: 'Aucune application de diffusion configurée.',
      wifi: 'Wi-Fi',
      password: 'Mot de passe',
      unsupported: 'La diffusion n’est pas prise en charge sur ce téléviseur.',
      hotspotStarting: 'Démarrage du point d’accès WiFi de ce téléviseur …',
      hotspotDown: 'Le point d’accès WiFi de ce téléviseur n’est pas actif actuellement. Veuillez contacter le personnel.',
      preparing: 'Préparation de la connexion …',
      waitingForPhone: 'En attente de la connexion du téléphone …',
      phoneConnected: 'Téléphone connecté',
      connectTitle: 'Connecter le téléphone',
      continueHint: 'Dès que votre téléphone est connecté : appuyez sur OK.',
      autoContinue: 'suite dans',
      stayHint: 'RETOUR : rester ici et afficher le code QR',
      tilesBackHint: 'RETOUR : afficher le code QR pour connecter le téléphone',
      castTilesHint: 'Ou depuis votre téléphone : ouvrez l’application (YouTube, Prime Video, Disney+ …), touchez l’icône Cast et choisissez ce téléviseur.',
      clearHint: 'Touche rouge : supprimer vos données de connexion de ce téléviseur',
      clearTitle: 'Supprimer les données de connexion',
      clearText: 'Vos connexions aux applications de ce téléviseur (Netflix, Spotify …) seront supprimées. Cela ne concerne que ce téléviseur, pas votre compte.',
      clearConfirm: 'Supprimer maintenant',
      clearCancel: 'Annuler',
      clearBusy: 'Suppression …',
      clearDone: 'Vos données de connexion ont été supprimées de ce téléviseur.',
      clearRebootText: 'Ce téléviseur ne peut supprimer les données de connexion qu’au redémarrage. Redémarrer maintenant ? Cela prend environ une minute.',
      clearRebootNow: 'Redémarrer maintenant',
      clearRebootLater: 'Plus tard',
      clearLater: 'Les données de connexion seront supprimées lors du prochain arrêt et rallumage du téléviseur.',
      clearClose: 'OK',
      launching: '{app} démarre …',
      installing: 'Installation de {app} sur ce téléviseur …',
      installWait: 'Cela peut prendre un moment.',
      unavailable: '{app} n\'est actuellement pas disponible sur ce téléviseur.',
      installFailed: '{app} n\'a pas pu être installé et n\'est actuellement pas disponible sur ce téléviseur.',
      unavailableHint: 'Veuillez vous adresser à la réception.',
      unavailableKeys: 'OK : autres applications · RETOUR : accueil',
    },
    epg: {
      title: 'Programme TV',
      loading: 'Chargement du programme …',
      noData: 'Aucune information sur le programme',
      noDescription: 'Aucune information complémentaire disponible.',
      running: 'en cours',
      nowOnAir: 'Actuellement sur cette chaîne',
      hint: 'Flèches : naviguer · OK : détails · VERT : revenir à maintenant · RETOUR : quitter',
      infoHint: 'GAUCHE/DROITE : liste ↔ texte · HAUT/BAS : changer de chaîne ou défiler · OK : regarder · RETOUR : programme',
    },
    dateISO: 'fr-FR',
  },
  it: {
    language: {
      name: 'Lingua',
      title: 'Selezionare la lingua',
      description: 'Selezionare la lingua del sistema.',
    },
    room: {
      name: 'Camera',
    },
    back: {
      name: 'Indietro',
    },
    channel: {
      name: 'Canale',
    },
    cast: {
      title: 'Cast',
      pairing: 'Scansiona il codice QR con il telefono per collegarti al televisore e trasmettere.',
      pairingNative: 'Sul telefono apri Google Cast o AirPlay e seleziona questo televisore.',
      pairingNetwork: 'Scansiona il codice QR per collegarti alla stessa rete Wi-Fi del televisore, poi apri Google Cast o AirPlay sul telefono.',
      pairingScreenShare: 'Apri la condivisione dello schermo sul telefono e seleziona questo televisore.',
      castEntryHint: 'Tasto blu: apri la condivisione dello schermo sul televisore',
      castSettingsHint: 'Tasto blu: apri le impostazioni Google Cast del televisore',
      noApps: 'Nessuna app di trasmissione configurata.',
      wifi: 'Wi-Fi',
      password: 'Password',
      unsupported: 'La trasmissione non è supportata su questo televisore.',
      hotspotStarting: 'Avvio dell’hotspot WiFi di questo televisore …',
      hotspotDown: 'L’hotspot WiFi di questo televisore non è attivo al momento. Si rivolga al personale.',
      preparing: 'Preparazione della connessione …',
      waitingForPhone: 'In attesa della connessione del telefono …',
      phoneConnected: 'Telefono connesso',
      connectTitle: 'Collega il telefono',
      continueHint: 'Quando il telefono è collegato: premere OK.',
      autoContinue: 'avanti tra',
      stayHint: 'INDIETRO: restare qui e mostrare il codice QR',
      tilesBackHint: 'INDIETRO: mostrare il codice QR per collegare il telefono',
      castTilesHint: 'Oppure dal telefono: aprire l’app (YouTube, Prime Video, Disney+ …), toccare l’icona Cast e scegliere questo TV.',
      clearHint: 'Tasto rosso: eliminare i dati di accesso da questo televisore',
      clearTitle: 'Eliminare i dati di accesso',
      clearText: 'I tuoi accessi alle app di questo televisore (Netflix, Spotify …) verranno rimossi. Riguarda solo questo televisore, non il tuo account.',
      clearConfirm: 'Elimina ora',
      clearCancel: 'Annulla',
      clearBusy: 'Eliminazione …',
      clearDone: 'I tuoi dati di accesso sono stati rimossi da questo televisore.',
      clearRebootText: 'Questo televisore può rimuovere i dati di accesso solo al riavvio. Riavviare ora? Richiede circa un minuto.',
      clearRebootNow: 'Riavvia ora',
      clearRebootLater: 'Più tardi',
      clearLater: 'I dati di accesso verranno rimossi al prossimo spegnimento e riaccensione del televisore.',
      clearClose: 'OK',
      launching: 'Avvio di {app} …',
      installing: 'Installazione di {app} su questo televisore …',
      installWait: 'Potrebbe richiedere qualche istante.',
      unavailable: '{app} al momento non è disponibile su questo televisore.',
      installFailed: 'Non è stato possibile installare {app}: al momento non è disponibile su questo televisore.',
      unavailableHint: 'Si prega di rivolgersi alla reception.',
      unavailableKeys: 'OK: altre app · INDIETRO: pagina iniziale',
    },
    epg: {
      title: 'Programmi TV',
      loading: 'Caricamento dei programmi …',
      noData: 'Nessuna informazione sul programma',
      noDescription: 'Nessuna ulteriore informazione disponibile.',
      running: 'in corso',
      nowOnAir: 'In onda ora su questo canale',
      hint: 'Frecce: naviga · OK: dettagli · VERDE: torna a ora · INDIETRO: esci',
      infoHint: 'SINISTRA/DESTRA: elenco ↔ testo · SU/GIÙ: cambia canale o scorri · OK: guarda · INDIETRO: programmi',
    },
    dateISO: 'it-IT',
  },
  es: {
    language: {
      name: 'Idiomas',
      title: 'Seleccionar idioma',
      description: 'Seleccionar idioma del Sistema',
    },
    room: {
      name: 'Habitación',
    },
    back: {
      name: 'Volver',
    },
    channel: {
      name: 'Canal',
    },
    cast: {
      title: 'Cast',
      pairing: 'Escanee el código QR con su teléfono para conectarse al televisor y emitir.',
      pairingNative: 'En su teléfono, abra Google Cast o AirPlay y seleccione este televisor.',
      pairingNetwork: 'Escanee el código QR para conectarse a la misma red Wi-Fi que el televisor y abra después Google Cast o AirPlay en su teléfono.',
      pairingScreenShare: 'Abra la compartición de pantalla en su teléfono y seleccione este televisor.',
      castEntryHint: 'Tecla azul: abrir la compartición de pantalla en el televisor',
      castSettingsHint: 'Tecla azul: abrir los ajustes de Google Cast del televisor',
      noApps: 'No hay aplicaciones de emisión configuradas.',
      wifi: 'Wi-Fi',
      password: 'Contraseña',
      unsupported: 'Este televisor no admite la emisión.',
      hotspotStarting: 'Iniciando el punto de acceso WiFi de este televisor …',
      hotspotDown: 'El punto de acceso WiFi de este televisor no está activo en este momento. Diríjase al personal.',
      preparing: 'Preparando la conexión …',
      waitingForPhone: 'Esperando la conexión del teléfono …',
      phoneConnected: 'Teléfono conectado',
      connectTitle: 'Conectar el teléfono',
      continueHint: 'Cuando su teléfono esté conectado: pulse OK.',
      autoContinue: 'continúa en',
      stayHint: 'ATRÁS: quedarse aquí y mostrar el código QR',
      tilesBackHint: 'ATRÁS: mostrar el código QR para conectar el teléfono',
      castTilesHint: 'O desde el teléfono: abra la app (YouTube, Prime Video, Disney+ …), toque el icono de Cast y elija este televisor.',
      clearHint: 'Tecla roja: eliminar sus datos de acceso de este televisor',
      clearTitle: 'Eliminar datos de acceso',
      clearText: 'Se eliminarán sus inicios de sesión en las aplicaciones de este televisor (Netflix, Spotify …). Solo afecta a este televisor, no a su cuenta.',
      clearConfirm: 'Eliminar ahora',
      clearCancel: 'Cancelar',
      clearBusy: 'Eliminando …',
      clearDone: 'Sus datos de acceso se han eliminado de este televisor.',
      clearRebootText: 'Este televisor solo puede eliminar los datos de acceso al reiniciarse. ¿Reiniciar ahora? Tarda alrededor de un minuto.',
      clearRebootNow: 'Reiniciar ahora',
      clearRebootLater: 'Más tarde',
      clearLater: 'Los datos de acceso se eliminarán la próxima vez que apague y encienda el televisor.',
      clearClose: 'OK',
      launching: 'Iniciando {app} …',
      installing: 'Instalando {app} en este televisor …',
      installWait: 'Esto puede tardar un momento.',
      unavailable: '{app} no está disponible en este televisor en este momento.',
      installFailed: 'No se ha podido instalar {app}: no está disponible en este televisor en este momento.',
      unavailableHint: 'Por favor, diríjase a la recepción.',
      unavailableKeys: 'OK: otras aplicaciones · ATRÁS: inicio',
    },
    epg: {
      title: 'Guía de TV',
      loading: 'Cargando la programación …',
      noData: 'Sin información de programación',
      noDescription: 'No hay más información disponible.',
      running: 'en directo',
      nowOnAir: 'Ahora en este canal',
      hint: 'Flechas: navegar · OK: detalles · VERDE: volver a ahora · ATRÁS: salir',
      infoHint: 'IZQUIERDA/DERECHA: lista ↔ texto · ARRIBA/ABAJO: cambiar canal o desplazar · OK: ver · ATRÁS: guía',
    },
    dateISO: 'es-ES',
  },
  tr: {
    language: {
      name: 'Dil',
      title: 'Dil Seçiniz',
      description: 'Sistem dilini seçin.',
    },
    room: {
      name: 'Oda',
    },
    back: {
      name: 'Geri',
    },
    channel: {
      name: 'Kanal',
    },
    cast: {
      title: 'Cast',
      pairing: 'Televizyona bağlanmak ve yayın yapmak için QR kodunu telefonunuzla okutun.',
      pairingNative: 'Telefonunuzda Google Cast veya AirPlay’i açın ve bu televizyonu seçin.',
      pairingNetwork: 'Televizyonla aynı Wi-Fi ağına katılmak için QR kodunu okutun, ardından telefonunuzda Google Cast veya AirPlay’i açın.',
      pairingScreenShare: 'Telefonunuzda ekran paylaşımını açın ve bu televizyonu seçin.',
      castEntryHint: 'Mavi tuş: televizyonda ekran paylaşımını aç',
      castSettingsHint: 'Mavi tuş: televizyonun Google Cast ayarlarını aç',
      noApps: 'Yapılandırılmış yayın uygulaması yok.',
      wifi: 'Wi-Fi',
      password: 'Şifre',
      unsupported: 'Bu televizyonda yayın desteklenmiyor.',
      hotspotStarting: 'Bu televizyonun WiFi noktası başlatılıyor …',
      hotspotDown: 'Bu televizyonun WiFi noktası şu anda etkin değil. Lütfen personele başvurun.',
      preparing: 'Bağlantı hazırlanıyor …',
      waitingForPhone: 'Telefonun bağlanması bekleniyor …',
      phoneConnected: 'Telefon bağlandı',
      connectTitle: 'Telefonu bağla',
      continueHint: 'Telefonunuz bağlandığında: OK tuşuna basın.',
      autoContinue: 'devam:',
      stayHint: 'GERİ: burada kal ve QR kodunu göster',
      tilesBackHint: 'GERİ: telefonu bağlamak için QR kodunu göster',
      castTilesHint: 'Veya telefonunuzdan: uygulamayı açın (YouTube, Prime Video, Disney+ …), Cast simgesine dokunun ve bu TV’yi seçin.',
      clearHint: 'Kırmızı tuş: oturum bilgilerinizi bu televizyondan silin',
      clearTitle: 'Oturum bilgilerini sil',
      clearText: 'Bu televizyondaki uygulamalarda (Netflix, Spotify …) yaptığınız oturum açma bilgileri kaldırılacak. Bu yalnızca televizyonu etkiler, hesabınızı etkilemez.',
      clearConfirm: 'Şimdi sil',
      clearCancel: 'İptal',
      clearBusy: 'Siliniyor …',
      clearDone: 'Oturum bilgileriniz bu televizyondan kaldırıldı.',
      clearRebootText: 'Bu televizyon oturum bilgilerini yalnızca yeniden başlatılırken kaldırabilir. Şimdi yeniden başlatılsın mı? Yaklaşık bir dakika sürer.',
      clearRebootNow: 'Şimdi yeniden başlat',
      clearRebootLater: 'Daha sonra',
      clearLater: 'Oturum bilgileri, televizyon kapatılıp yeniden açıldığında kaldırılacak.',
      clearClose: 'Tamam',
      launching: '{app} başlatılıyor …',
      installing: '{app} bu televizyona yükleniyor …',
      installWait: 'Bu biraz zaman alabilir.',
      unavailable: '{app} şu anda bu televizyonda kullanılamıyor.',
      installFailed: '{app} yüklenemedi ve şu anda bu televizyonda kullanılamıyor.',
      unavailableHint: 'Lütfen resepsiyona başvurun.',
      unavailableKeys: 'OK: diğer uygulamalar · GERİ: ana ekran',
    },
    epg: {
      title: 'TV Rehberi',
      loading: 'Yayın akışı yükleniyor …',
      noData: 'Program bilgisi yok',
      noDescription: 'Başka bilgi bulunmuyor.',
      running: 'yayında',
      nowOnAir: 'Şu anda bu kanalda',
      hint: 'Oklar: gezinme · OK: ayrıntılar · YEŞİL: şimdiye dön · GERİ: çıkış',
      infoHint: 'SOL/SAĞ: liste ↔ metin · YUKARI/AŞAĞI: kanal değiştir veya kaydır · OK: izle · GERİ: rehber',
    },
    dateISO: 'tr-TR',
  },
  ru: {
    language: {
      name: 'Язык',
      title: "Выбрать язык",
      description: "Выберите язык системы.",
    },
    room: {
      name: 'Комната',
    },
    back: {
      name: 'Назад',
    },
    channel: {
      name: 'Канал',
    },
    cast: {
      title: 'Cast',
      pairing: 'Отсканируйте QR-код телефоном, чтобы подключиться к телевизору и начать трансляцию.',
      pairingNative: 'Откройте на телефоне Google Cast или AirPlay и выберите этот телевизор.',
      pairingNetwork: 'Отсканируйте QR-код, чтобы подключиться к той же сети Wi-Fi, что и телевизор, затем откройте на телефоне Google Cast или AirPlay.',
      pairingScreenShare: 'Откройте на телефоне повтор экрана и выберите этот телевизор.',
      castEntryHint: 'Синяя кнопка: открыть повтор экрана на телевизоре',
      castSettingsHint: 'Синяя кнопка: открыть настройки Google Cast телевизора',
      noApps: 'Приложения для трансляции не настроены.',
      wifi: 'Wi-Fi',
      password: 'Пароль',
      unsupported: 'Этот телевизор не поддерживает трансляцию.',
      hotspotStarting: 'Запуск точки доступа WiFi этого телевизора …',
      hotspotDown: 'Точка доступа WiFi этого телевизора сейчас не активна. Обратитесь к персоналу.',
      preparing: 'Подготовка подключения …',
      waitingForPhone: 'Ожидание подключения телефона …',
      phoneConnected: 'Телефон подключён',
      connectTitle: 'Подключить телефон',
      continueHint: 'Как только телефон подключён: нажмите OK.',
      autoContinue: 'далее через',
      stayHint: 'НАЗАД: остаться здесь и показать QR-код',
      tilesBackHint: 'НАЗАД: показать QR-код для подключения телефона',
      castTilesHint: 'Или с телефона: откройте приложение (YouTube, Prime Video, Disney+ …), нажмите значок трансляции и выберите этот телевизор.',
      clearHint: 'Красная кнопка: удалить ваши данные входа с этого телевизора',
      clearTitle: 'Удалить данные входа',
      clearText: 'Ваши входы в приложения на этом телевизоре (Netflix, Spotify …) будут удалены. Это касается только телевизора, а не вашей учётной записи.',
      clearConfirm: 'Удалить',
      clearCancel: 'Отмена',
      clearBusy: 'Удаление …',
      clearDone: 'Ваши данные входа удалены с этого телевизора.',
      clearRebootText: 'Этот телевизор может удалить данные входа только при перезапуске. Перезапустить сейчас? Это занимает около минуты.',
      clearRebootNow: 'Перезапустить',
      clearRebootLater: 'Позже',
      clearLater: 'Данные входа будут удалены при следующем выключении и включении телевизора.',
      clearClose: 'OK',
      launching: 'Запуск {app} …',
      installing: 'Установка {app} на этот телевизор …',
      installWait: 'Это может занять некоторое время.',
      unavailable: '{app} сейчас недоступно на этом телевизоре.',
      installFailed: 'Не удалось установить {app}: сейчас приложение недоступно на этом телевизоре.',
      unavailableHint: 'Пожалуйста, обратитесь на ресепшн.',
      unavailableKeys: 'OK: другие приложения · НАЗАД: главный экран',
    },
    epg: {
      title: 'Телепрограмма',
      loading: 'Загрузка телепрограммы …',
      noData: 'Нет данных о программе',
      noDescription: 'Дополнительных сведений нет.',
      running: 'в эфире',
      nowOnAir: 'Сейчас на этом канале',
      hint: 'Стрелки: навигация · OK: подробности · ЗЕЛЁНАЯ: к текущему времени · НАЗАД: выход',
      infoHint: 'ВЛЕВО/ВПРАВО: список ↔ текст · ВВЕРХ/ВНИЗ: сменить канал или прокрутка · OK: смотреть · НАЗАД: программа',
    },
    dateISO: 'ru-RU',
  },
  nl: {
    language: {
      name: 'Taal',
      title: "Selecteer taal",
      description: "Selecteer de systeemtaal.",
    },
    room: {
      name: 'Kamer',
    },
    back: {
      name: 'Terug',
    },
    channel: {
      name: 'Kanaal',
    },
    cast: {
      title: 'Cast',
      pairing: 'Scan de QR-code met uw telefoon om verbinding te maken met de tv en te casten.',
      pairingNative: 'Open op uw telefoon Google Cast of AirPlay en selecteer deze tv.',
      pairingNetwork: 'Scan de QR-code om verbinding te maken met hetzelfde wifinetwerk als de tv en open daarna Google Cast of AirPlay op uw telefoon.',
      pairingScreenShare: 'Open Screen Share op uw telefoon en selecteer deze tv.',
      castEntryHint: 'Blauwe toets: Screen Share op de tv openen',
      castSettingsHint: 'Blauwe toets: Google Cast-instellingen van de tv openen',
      noApps: 'Geen cast-apps geconfigureerd.',
      wifi: 'Wifi',
      password: 'Wachtwoord',
      unsupported: 'Casten wordt op deze tv niet ondersteund.',
      hotspotStarting: 'De WiFi-hotspot van deze tv wordt gestart …',
      hotspotDown: 'De WiFi-hotspot van deze tv is momenteel niet actief. Neem contact op met het personeel.',
      preparing: 'Verbinding wordt voorbereid …',
      waitingForPhone: 'Wachten op verbinding met de telefoon …',
      phoneConnected: 'Telefoon verbonden',
      connectTitle: 'Telefoon verbinden',
      continueHint: 'Zodra uw telefoon verbonden is: druk op OK.',
      autoContinue: 'verder over',
      stayHint: 'TERUG: hier blijven en QR-code tonen',
      tilesBackHint: 'TERUG: QR-code tonen om uw telefoon te verbinden',
      castTilesHint: 'Of vanaf uw telefoon: open de app (YouTube, Prime Video, Disney+ …), tik op het cast-pictogram en kies deze tv.',
      clearHint: 'Rode toets: uw aanmeldgegevens van deze tv verwijderen',
      clearTitle: 'Aanmeldgegevens verwijderen',
      clearText: 'Uw aanmeldingen bij de apps op deze tv (Netflix, Spotify …) worden verwijderd. Dit geldt alleen voor deze tv, niet voor uw account.',
      clearConfirm: 'Nu verwijderen',
      clearCancel: 'Annuleren',
      clearBusy: 'Verwijderen …',
      clearDone: 'Uw aanmeldgegevens zijn van deze tv verwijderd.',
      clearRebootText: 'Deze tv kan de aanmeldgegevens alleen tijdens het opnieuw opstarten verwijderen. Nu opnieuw opstarten? Dit duurt ongeveer een minuut.',
      clearRebootNow: 'Nu opnieuw opstarten',
      clearRebootLater: 'Later',
      clearLater: 'De aanmeldgegevens worden verwijderd zodra de tv wordt uit- en weer aangezet.',
      clearClose: 'OK',
      launching: '{app} wordt gestart …',
      installing: '{app} wordt op deze tv geïnstalleerd …',
      installWait: 'Dit kan even duren.',
      unavailable: '{app} is momenteel niet beschikbaar op deze tv.',
      installFailed: '{app} kon niet worden geïnstalleerd en is momenteel niet beschikbaar op deze tv.',
      unavailableHint: 'Neem contact op met de receptie.',
      unavailableKeys: 'OK: andere apps · TERUG: startscherm',
    },
    epg: {
      title: 'Tv-gids',
      loading: 'Programmagegevens worden geladen …',
      noData: 'Geen programma-informatie',
      noDescription: 'Geen verdere informatie beschikbaar.',
      running: 'nu op tv',
      nowOnAir: 'Nu op dit kanaal',
      hint: 'Pijltjes: navigeren · OK: details · GROEN: terug naar nu · TERUG: sluiten',
      infoHint: 'LINKS/RECHTS: lijst ↔ tekst · OMHOOG/OMLAAG: kanaal wisselen of scrollen · OK: kijken · TERUG: overzicht',
    },
    dateISO: 'nl-NL',
  },
  ar: {
    language: {
      name: 'اللغة',
      title: "تحديد اللغة",
      description: "حدد لغة النظام.",
    },
    room: {
      name: 'الغرفة',
    },
    back: {
      name: 'الخلفية',
    },
    channel: {
      name: 'القناة',
    },
    cast: {
      title: 'Cast',
      pairing: 'امسح رمز الاستجابة السريعة بهاتفك للاتصال بالتلفزيون وبدء البث.',
      pairingNative: 'افتح Google Cast أو AirPlay على هاتفك واختر هذا التلفزيون.',
      pairingNetwork: 'امسح رمز الاستجابة السريعة للاتصال بشبكة Wi-Fi نفسها التي يستخدمها التلفزيون، ثم افتح Google Cast أو AirPlay على هاتفك.',
      pairingScreenShare: 'افتح مشاركة الشاشة على هاتفك واختر هذا التلفزيون.',
      castEntryHint: 'الزر الأزرق: فتح مشاركة الشاشة على التلفزيون',
      castSettingsHint: 'الزر الأزرق: فتح إعدادات Google Cast في التلفزيون',
      noApps: 'لا توجد تطبيقات بث مهيأة.',
      wifi: 'Wi-Fi',
      password: 'كلمة المرور',
      unsupported: 'البث غير مدعوم على هذا التلفزيون.',
      hotspotStarting: 'جارٍ تشغيل نقطة اتصال WiFi لهذا التلفزيون …',
      hotspotDown: 'نقطة اتصال WiFi في هذا التلفزيون غير مُفعَّلة حالياً. يُرجى مراجعة الموظفين.',
      preparing: 'جارٍ تحضير الاتصال …',
      waitingForPhone: 'في انتظار اتصال الهاتف …',
      phoneConnected: 'تم توصيل الهاتف',
      connectTitle: 'توصيل الهاتف',
      continueHint: 'عندما يتصل هاتفك: اضغط على OK.',
      autoContinue: 'المتابعة خلال',
      stayHint: 'رجوع: البقاء هنا وعرض رمز QR',
      tilesBackHint: 'رجوع: عرض رمز QR لتوصيل الهاتف',
      castTilesHint: 'أو من هاتفك: افتح التطبيق (YouTube وPrime Video وDisney+ …)، واضغط على رمز البث واختر هذا التلفزيون.',
      clearHint: 'الزر الأحمر: حذف بيانات تسجيل الدخول من هذا التلفزيون',
      clearTitle: 'حذف بيانات تسجيل الدخول',
      clearText: 'سيتم حذف تسجيلات الدخول الخاصة بك في تطبيقات هذا التلفزيون (Netflix، Spotify …). هذا يخص التلفزيون فقط وليس حسابك.',
      clearConfirm: 'الحذف الآن',
      clearCancel: 'إلغاء',
      clearBusy: 'جارٍ الحذف …',
      clearDone: 'تم حذف بيانات تسجيل الدخول من هذا التلفزيون.',
      clearRebootText: 'لا يمكن لهذا التلفزيون حذف بيانات تسجيل الدخول إلا عند إعادة التشغيل. هل تريد إعادة التشغيل الآن؟ يستغرق ذلك نحو دقيقة.',
      clearRebootNow: 'إعادة التشغيل الآن',
      clearRebootLater: 'لاحقاً',
      clearLater: 'سيتم حذف بيانات تسجيل الدخول عند إيقاف التلفزيون ثم تشغيله مرة أخرى.',
      clearClose: 'حسناً',
      launching: 'جارٍ تشغيل {app} …',
      installing: 'جارٍ تثبيت {app} على هذا التلفزيون …',
      installWait: 'قد يستغرق ذلك بعض الوقت.',
      unavailable: '{app} غير متاح حاليًا على هذا التلفزيون.',
      installFailed: 'تعذّر تثبيت {app}، وهو غير متاح حاليًا على هذا التلفزيون.',
      unavailableHint: 'يُرجى التواصل مع مكتب الاستقبال.',
      unavailableKeys: 'OK: تطبيقات أخرى · رجوع: الشاشة الرئيسية',
    },
    epg: {
      title: 'دليل البرامج',
      loading: 'جارٍ تحميل بيانات البرامج …',
      noData: 'لا توجد معلومات عن البرامج',
      noDescription: 'لا تتوفر معلومات إضافية.',
      running: 'يُبث الآن',
      nowOnAir: 'يُبث الآن على هذه القناة',
      hint: 'الأسهم: التنقل · OK: التفاصيل · الأخضر: العودة إلى الآن · رجوع: خروج',
      infoHint: 'يسار/يمين: القائمة ↔ النص · أعلى/أسفل: تغيير القناة أو التمرير · OK: مشاهدة · رجوع: الدليل',
    },
    dateISO: 'ar-SY',
  },
  ko: {
    language: {
      name: '언어',
      title: "언어 선택",
      description: "시스템 언어를 선택합니다.",
    },
    room: {
      name: '방',
    },
    back: {
      name: '뒤로',
    },
    channel: {
      name: '채널',
    },
    cast: {
      title: 'Cast',
      pairing: '휴대폰으로 QR 코드를 스캔하여 TV에 연결한 후 캐스트하세요.',
      pairingNative: '휴대폰에서 Google Cast 또는 AirPlay를 열고 이 TV를 선택하세요.',
      pairingNetwork: 'QR 코드를 스캔하여 TV와 같은 Wi-Fi에 연결한 다음 휴대폰에서 Google Cast 또는 AirPlay를 여세요.',
      pairingScreenShare: '휴대폰에서 화면 공유를 열고 이 TV를 선택하세요.',
      castEntryHint: '파란색 버튼: TV에서 화면 공유 열기',
      castSettingsHint: '파란색 버튼: TV의 Google Cast 설정 열기',
      noApps: '설정된 캐스트 앱이 없습니다.',
      wifi: 'Wi-Fi',
      password: '비밀번호',
      unsupported: '이 TV에서는 캐스트를 지원하지 않습니다.',
      hotspotStarting: '이 TV의 WiFi 핫스팟을 시작하고 있습니다 …',
      hotspotDown: '이 TV의 WiFi 핫스팟이 현재 활성화되어 있지 않습니다. 직원에게 문의해 주십시오.',
      preparing: '연결을 준비하고 있습니다 …',
      waitingForPhone: '휴대폰 연결을 기다리는 중 …',
      phoneConnected: '휴대폰 연결됨',
      connectTitle: '휴대폰 연결',
      continueHint: '훴대폰이 연결되면 OK를 누르십시오.',
      autoContinue: '다음 단계까지',
      stayHint: '뒤로: 여기 머물며 QR 코드 표시',
      tilesBackHint: '뒤로: 휴대폰 연결용 QR 코드 표시',
      castTilesHint: '또는 휴대폰에서: 앱(YouTube, Prime Video, Disney+ …)을 열고 전송 아이콘을 눌러 이 TV를 선택하십시오.',
      clearHint: '빨간색 버튼: 이 TV에서 로그인 정보 삭제',
      clearTitle: '로그인 정보 삭제',
      clearText: '이 TV의 앱(Netflix, Spotify …)에 로그인한 정보가 삭제됩니다. 이 TV에만 적용되며 계정은 그대로 유지됩니다.',
      clearConfirm: '지금 삭제',
      clearCancel: '취소',
      clearBusy: '삭제 중 …',
      clearDone: '로그인 정보가 이 TV에서 삭제되었습니다.',
      clearRebootText: '이 TV는 다시 시작할 때만 로그인 정보를 삭제할 수 있습니다. 지금 다시 시작하시겠습니까? 약 1분 정도 걸립니다.',
      clearRebootNow: '지금 다시 시작',
      clearRebootLater: '나중에',
      clearLater: 'TV를 끄고 다시 켤 때 로그인 정보가 삭제됩니다.',
      clearClose: '확인',
      launching: '{app}을(를) 시작하는 중 …',
      installing: '이 TV에 {app}을(를) 설치하는 중 …',
      installWait: '잠시 시간이 걸릴 수 있습니다.',
      unavailable: '현재 이 TV에서는 {app}을(를) 사용할 수 없습니다.',
      installFailed: '{app}을(를) 설치할 수 없어 현재 이 TV에서 사용할 수 없습니다.',
      unavailableHint: '프런트 데스크에 문의해 주세요.',
      unavailableKeys: 'OK: 다른 앱 · 뒤로: 홈 화면',
    },
    epg: {
      title: 'TV 편성표',
      loading: '편성 정보를 불러오는 중 …',
      noData: '편성 정보 없음',
      noDescription: '추가 정보가 없습니다.',
      running: '방송 중',
      nowOnAir: '현재 이 채널에서 방송 중',
      hint: '방향키: 이동 · OK: 상세 정보 · 초록: 현재 시각으로 · 뒤로: 나가기',
      infoHint: '좌/우: 채널 목록 ↔ 설명 · 상/하: 채널 변경 또는 스크롤 · OK: 시청 · 뒤로: 편성표',
    },
    dateISO: 'ko-KR',
  },
  el: {
    language: {
      name: 'γλώσσα',
      title: "Επιλέξτε γλώσσα",
      description: "Επιλέξτε τη γλώσσα του συστήματος.",
    },
    room: {
      name: 'Δωμάτιο',
    },
    back: {
      name: 'Πίσω στο',
    },
    channel: {
      name: 'Κανάλι',
    },
    cast: {
      title: 'Cast',
      pairing: 'Σαρώστε τον κωδικό QR με το κινητό σας για σύνδεση με την τηλεόραση και μετάδοση.',
      pairingNative: 'Στο κινητό σας ανοίξτε το Google Cast ή το AirPlay και επιλέξτε αυτήν την τηλεόραση.',
      pairingNetwork: 'Σαρώστε τον κωδικό QR για να συνδεθείτε στο ίδιο δίκτυο Wi-Fi με την τηλεόραση και μετά ανοίξτε το Google Cast ή το AirPlay στο κινητό σας.',
      pairingScreenShare: 'Ανοίξτε την κοινή χρήση οθόνης στο κινητό σας και επιλέξτε αυτήν την τηλεόραση.',
      castEntryHint: 'Μπλε πλήκτρο: άνοιγμα κοινής χρήσης οθόνης στην τηλεόραση',
      castSettingsHint: 'Μπλε πλήκτρο: άνοιγμα ρυθμίσεων Google Cast της τηλεόρασης',
      noApps: 'Δεν έχουν ρυθμιστεί εφαρμογές μετάδοσης.',
      wifi: 'Wi-Fi',
      password: 'Κωδικός',
      unsupported: 'Η μετάδοση δεν υποστηρίζεται σε αυτήν την τηλεόραση.',
      hotspotStarting: 'Εκκίνηση του σημείου πρόσβασης WiFi …',
      hotspotDown: 'Το σημείο πρόσβασης WiFi αυτής της τηλεόρασης δεν είναι ενεργό αυτή τη στιγμή. Απευθυνθείτε στο προσωπικό.',
      preparing: 'Προετοιμασία σύνδεσης …',
      waitingForPhone: 'Αναμονή για σύνδεση του τηλεφώνου …',
      phoneConnected: 'Το τηλέφωνο συνδέθηκε',
      connectTitle: 'Σύνδεση τηλεφώνου',
      continueHint: 'Μόλις συνδεθεί το τηλέφωνό σας: πατήστε OK.',
      autoContinue: 'συνέχεια σε',
      stayHint: 'ΠΙΣΩ: παραμονή εδώ και εμφάνιση του κωδικού QR',
      tilesBackHint: 'ΠΙΣΩ: εμφάνιση του κωδικού QR για σύνδεση του τηλεφώνου',
      castTilesHint: 'Ή από το τηλέφωνο: ανοίξτε την εφαρμογή (YouTube, Prime Video, Disney+ …), πατήστε το εικονίδιο Cast και επιλέξτε αυτή την τηλεόραση.',
      clearHint: 'Κόκκινο πλήκτρο: διαγραφή των στοιχείων σύνδεσής σας από την τηλεόραση',
      clearTitle: 'Διαγραφή στοιχείων σύνδεσης',
      clearText: 'Οι συνδέσεις σας στις εφαρμογές αυτής της τηλεόρασης (Netflix, Spotify …) θα διαγραφούν. Αφορά μόνο αυτήν την τηλεόραση, όχι τον λογαριασμό σας.',
      clearConfirm: 'Διαγραφή τώρα',
      clearCancel: 'Άκυρο',
      clearBusy: 'Διαγραφή …',
      clearDone: 'Τα στοιχεία σύνδεσής σας διαγράφηκαν από αυτήν την τηλεόραση.',
      clearRebootText: 'Αυτή η τηλεόραση μπορεί να διαγράψει τα στοιχεία σύνδεσης μόνο κατά την επανεκκίνηση. Επανεκκίνηση τώρα; Διαρκεί περίπου ένα λεπτό.',
      clearRebootNow: 'Επανεκκίνηση τώρα',
      clearRebootLater: 'Αργότερα',
      clearLater: 'Τα στοιχεία σύνδεσης θα διαγραφούν την επόμενη φορά που θα σβήσει και θα ανάψει η τηλεόραση.',
      clearClose: 'OK',
      launching: 'Εκκίνηση {app} …',
      installing: 'Εγκατάσταση {app} σε αυτήν την τηλεόραση …',
      installWait: 'Αυτό μπορεί να διαρκέσει λίγο.',
      unavailable: 'Το {app} δεν είναι διαθέσιμο αυτήν τη στιγμή σε αυτήν την τηλεόραση.',
      installFailed: 'Η εγκατάσταση του {app} δεν ήταν δυνατή· δεν είναι διαθέσιμο αυτήν τη στιγμή σε αυτήν την τηλεόραση.',
      unavailableHint: 'Παρακαλούμε απευθυνθείτε στη ρεσεψιόν.',
      unavailableKeys: 'OK: άλλες εφαρμογές · ΠΙΣΩ: αρχική οθόνη',
    },
    epg: {
      title: 'Τηλεοπτικό πρόγραμμα',
      loading: 'Φόρτωση προγράμματος …',
      noData: 'Δεν υπάρχουν πληροφορίες προγράμματος',
      noDescription: 'Δεν υπάρχουν περισσότερες πληροφορίες.',
      running: 'σε εξέλιξη',
      nowOnAir: 'Τώρα σε αυτό το κανάλι',
      hint: 'Βέλη: πλοήγηση · OK: λεπτομέρειες · ΠΡΑΣΙΝΟ: επιστροφή στο τώρα · ΠΙΣΩ: έξοδος',
      infoHint: 'ΑΡΙΣΤΕΡΑ/ΔΕΞΙΑ: λίστα ↔ κείμενο · ΠΑΝΩ/ΚΑΤΩ: αλλαγή καναλιού ή κύλιση · OK: παρακολούθηση · ΠΙΣΩ: πρόγραμμα',
    },
    dateISO: 'el-GR',
  },
  pt: {
    language: {
      name: 'Língua',
      title: "Selecionar o idioma",
      description: "Selecionar o idioma do sistema.",
    },
    room: {
      name: 'Sala',
    },
    back: {
      name: 'Voltar para',
    },
    channel: {
      name: 'Canal',
    },
    cast: {
      title: 'Cast',
      pairing: 'Digitalize o código QR com o telemóvel para se ligar ao televisor e transmitir.',
      pairingNative: 'No telemóvel, abra o Google Cast ou o AirPlay e selecione este televisor.',
      pairingNetwork: 'Digitalize o código QR para se ligar à mesma rede Wi-Fi do televisor e abra depois o Google Cast ou o AirPlay no telemóvel.',
      pairingScreenShare: 'Abra a partilha de ecrã no telemóvel e selecione este televisor.',
      castEntryHint: 'Tecla azul: abrir a partilha de ecrã no televisor',
      castSettingsHint: 'Tecla azul: abrir as definições do Google Cast do televisor',
      noApps: 'Nenhuma aplicação de transmissão configurada.',
      wifi: 'Wi-Fi',
      password: 'Palavra-passe',
      unsupported: 'A transmissão não é suportada neste televisor.',
      hotspotStarting: 'A iniciar o ponto de acesso WiFi deste televisor …',
      hotspotDown: 'O ponto de acesso WiFi deste televisor não está ativo neste momento. Contacte o pessoal.',
      preparing: 'A preparar a ligação …',
      waitingForPhone: 'A aguardar a ligação do telemóvel …',
      phoneConnected: 'Telemóvel ligado',
      connectTitle: 'Ligar o telemóvel',
      continueHint: 'Quando o seu telemóvel estiver ligado: prima OK.',
      autoContinue: 'continua em',
      stayHint: 'VOLTAR: ficar aqui e mostrar o código QR',
      tilesBackHint: 'VOLTAR: mostrar o código QR para ligar o telemóvel',
      castTilesHint: 'Ou a partir do telemóvel: abra a app (YouTube, Prime Video, Disney+ …), toque no ícone Cast e escolha esta TV.',
      clearHint: 'Tecla vermelha: eliminar os seus dados de acesso deste televisor',
      clearTitle: 'Eliminar dados de acesso',
      clearText: 'Os seus acessos às aplicações deste televisor (Netflix, Spotify …) serão removidos. Só afeta este televisor, não a sua conta.',
      clearConfirm: 'Eliminar agora',
      clearCancel: 'Cancelar',
      clearBusy: 'A eliminar …',
      clearDone: 'Os seus dados de acesso foram removidos deste televisor.',
      clearRebootText: 'Este televisor só pode remover os dados de acesso ao reiniciar. Reiniciar agora? Demora cerca de um minuto.',
      clearRebootNow: 'Reiniciar agora',
      clearRebootLater: 'Mais tarde',
      clearLater: 'Os dados de acesso serão removidos quando o televisor for desligado e ligado novamente.',
      clearClose: 'OK',
      launching: 'A iniciar {app} …',
      installing: 'A instalar {app} neste televisor …',
      installWait: 'Isto pode demorar um momento.',
      unavailable: '{app} não está disponível neste televisor de momento.',
      installFailed: 'Não foi possível instalar {app}: não está disponível neste televisor de momento.',
      unavailableHint: 'Por favor, dirija-se à receção.',
      unavailableKeys: 'OK: outras aplicações · VOLTAR: ecrã inicial',
    },
    epg: {
      title: 'Guia de TV',
      loading: 'A carregar a programação …',
      noData: 'Sem informação de programação',
      noDescription: 'Sem mais informação disponível.',
      running: 'em exibição',
      nowOnAir: 'Agora neste canal',
      hint: 'Setas: navegar · OK: detalhes · VERDE: voltar a agora · VOLTAR: sair',
      infoHint: 'ESQUERDA/DIREITA: lista ↔ texto · CIMA/BAIXO: mudar de canal ou deslocar · OK: ver · VOLTAR: guia',
    },
    dateISO: 'pt-PT',
  },
  hu: {
    language: {
      name: 'Nyelv',
      title: "Nyelv kiválasztása",
      description: "Válassza ki a rendszer nyelvét.",
    },
    room: {
      name: 'Szoba',
    },
    back: {
      name: 'Vissza a',
    },
    channel: {
      name: 'Csatorna',
    },
    cast: {
      title: 'Cast',
      pairing: 'Olvassa be a QR-kódot a telefonjával, hogy csatlakozzon a tv-hez és átvihesse a tartalmat.',
      pairingNative: 'Nyissa meg a telefonján a Google Castot vagy az AirPlayt, és válassza ki ezt a tv-t.',
      pairingNetwork: 'Olvassa be a QR-kódot, hogy ugyanahhoz a Wi-Fi-hálózathoz csatlakozzon, mint a tv, majd nyissa meg a telefonján a Google Castot vagy az AirPlayt.',
      pairingScreenShare: 'Nyissa meg a képernyőmegosztást a telefonján, és válassza ki ezt a tv-t.',
      castEntryHint: 'Kék gomb: képernyőmegosztás megnyitása a tv-n',
      castSettingsHint: 'Kék gomb: a tv Google Cast-beállításainak megnyitása',
      noApps: 'Nincs beállított átviteli alkalmazás.',
      wifi: 'Wi-Fi',
      password: 'Jelszó',
      unsupported: 'Ez a tv nem támogatja az átvitelt.',
      hotspotStarting: 'A tv WiFi hotspotjának indítása …',
      hotspotDown: 'Ennek a tv-nek a WiFi hotspotja jelenleg nem aktív. Kérjük, forduljon a személyzethez.',
      preparing: 'Kapcsolat előkészítése …',
      waitingForPhone: 'Várakozás a telefon csatlakozására …',
      phoneConnected: 'Telefon csatlakoztatva',
      connectTitle: 'Telefon csatlakoztatása',
      continueHint: 'Amint a telefon csatlakozott: nyomja meg az OK gombot.',
      autoContinue: 'tovább',
      stayHint: 'VISSZA: itt maradás és a QR-kód megjelenítése',
      tilesBackHint: 'VISSZA: QR-kód megjelenítése a telefon csatlakoztatásához',
      castTilesHint: 'Vagy a telefonról: nyissa meg az alkalmazást (YouTube, Prime Video, Disney+ …), koppintson a Cast ikonra, és válassza ezt a tévét.',
      clearHint: 'Piros gomb: bejelentkezési adatok törlése erről a tv-ről',
      clearTitle: 'Bejelentkezési adatok törlése',
      clearText: 'A tv alkalmazásaiba (Netflix, Spotify …) történt bejelentkezései törlődnek. Ez csak erre a tv-re vonatkozik, a fiókjára nem.',
      clearConfirm: 'Törlés most',
      clearCancel: 'Mégse',
      clearBusy: 'Törlés …',
      clearDone: 'A bejelentkezési adatai törlődtek erről a tv-ről.',
      clearRebootText: 'Ez a tv csak újraindításkor tudja törölni a bejelentkezési adatokat. Újraindítja most? Körülbelül egy percet vesz igénybe.',
      clearRebootNow: 'Újraindítás most',
      clearRebootLater: 'Később',
      clearLater: 'A bejelentkezési adatok a tv következő ki- és bekapcsolásakor törlődnek.',
      clearClose: 'OK',
      launching: '{app} indítása …',
      installing: '{app} telepítése erre a tv-re …',
      installWait: 'Ez eltarthat egy ideig.',
      unavailable: 'A(z) {app} jelenleg nem érhető el ezen a tv-n.',
      installFailed: 'A(z) {app} nem telepíthető, és jelenleg nem érhető el ezen a tv-n.',
      unavailableHint: 'Kérjük, forduljon a recepcióhoz.',
      unavailableKeys: 'OK: további alkalmazások · VISSZA: kezdőképernyő',
    },
    epg: {
      title: 'Tv-műsor',
      loading: 'Műsoradatok betöltése …',
      noData: 'Nincs műsorinformáció',
      noDescription: 'Nincs további információ.',
      running: 'most megy',
      nowOnAir: 'Most ezen a csatornán',
      hint: 'Nyilak: navigálás · OK: részletek · ZÖLD: vissza a jelenhez · VISSZA: kilépés',
      infoHint: 'BALRA/JOBBRA: lista ↔ szöveg · FEL/LE: csatornaváltás vagy görgetés · OK: megtekintés · VISSZA: műsor',
    },
    dateISO: 'hu-HU',
  },
  da: {
    language: {
      name: 'Sprog',
      title: "Vælg sprog",
      description: "Vælg systemets sprog.",
    },
    room: {
      name: 'Rum',
    },
    back: {
      name: 'Tilbage til',
    },
    channel: {
      name: 'Kanal',
    },
    cast: {
      title: 'Cast',
      pairing: 'Scan QR-koden med din telefon for at oprette forbindelse til tv’et og caste.',
      pairingNative: 'Åbn Google Cast eller AirPlay på din telefon, og vælg dette tv.',
      pairingNetwork: 'Scan QR-koden for at komme på det samme Wi-Fi som tv’et, og åbn derefter Google Cast eller AirPlay på din telefon.',
      pairingScreenShare: 'Åbn skærmdeling på din telefon, og vælg dette tv.',
      castEntryHint: 'Blå tast: åbn skærmdeling på tv’et',
      castSettingsHint: 'Blå tast: åbn tv’ets Google Cast-indstillinger',
      noApps: 'Ingen cast-apps er konfigureret.',
      wifi: 'Wi-Fi',
      password: 'Adgangskode',
      unsupported: 'Casting understøttes ikke på dette tv.',
      hotspotStarting: 'Starter dette tv’s WiFi-hotspot …',
      hotspotDown: 'Dette tv’s WiFi-hotspot er ikke aktivt i øjeblikket. Kontakt venligst personalet.',
      preparing: 'Forbindelsen forberedes …',
      waitingForPhone: 'Venter på, at telefonen tilsluttes …',
      phoneConnected: 'Telefon tilsluttet',
      connectTitle: 'Tilslut telefonen',
      continueHint: 'Når din telefon er forbundet: tryk OK.',
      autoContinue: 'fortsætter om',
      stayHint: 'TILBAGE: bliv her og vis QR-koden',
      tilesBackHint: 'TILBAGE: vis QR-koden for at forbinde din telefon',
      castTilesHint: 'Eller fra din telefon: åbn appen (YouTube, Prime Video, Disney+ …), tryk på cast-ikonet og vælg dette tv.',
      clearHint: 'Rød tast: slet dine loginoplysninger fra dette tv',
      clearTitle: 'Slet loginoplysninger',
      clearText: 'Dine logins i apperne på dette tv (Netflix, Spotify …) bliver fjernet. Det gælder kun dette tv, ikke din konto.',
      clearConfirm: 'Slet nu',
      clearCancel: 'Annuller',
      clearBusy: 'Sletter …',
      clearDone: 'Dine loginoplysninger er fjernet fra dette tv.',
      clearRebootText: 'Dette tv kan kun fjerne loginoplysningerne under en genstart. Genstart nu? Det tager cirka et minut.',
      clearRebootNow: 'Genstart nu',
      clearRebootLater: 'Senere',
      clearLater: 'Loginoplysningerne fjernes, næste gang tv’et slukkes og tændes igen.',
      clearClose: 'OK',
      launching: '{app} starter …',
      installing: '{app} installeres på dette tv …',
      installWait: 'Det kan tage et øjeblik.',
      unavailable: '{app} er i øjeblikket ikke tilgængelig på dette tv.',
      installFailed: '{app} kunne ikke installeres og er i øjeblikket ikke tilgængelig på dette tv.',
      unavailableHint: 'Kontakt venligst receptionen.',
      unavailableKeys: 'OK: andre apps · TILBAGE: startskærm',
    },
    epg: {
      title: 'Tv-guide',
      loading: 'Henter programdata …',
      noData: 'Ingen programoplysninger',
      noDescription: 'Ingen yderligere oplysninger.',
      running: 'sendes nu',
      nowOnAir: 'Lige nu på denne kanal',
      hint: 'Piletaster: naviger · OK: detaljer · GRØN: tilbage til nu · TILBAGE: luk',
      infoHint: 'VENSTRE/HØJRE: liste ↔ tekst · OP/NED: skift kanal eller rul · OK: se · TILBAGE: oversigt',
    },
    dateISO: 'da-DK',
  },
  sv: {
    language: {
      name: 'Språk',
      title: "Välj språk",
      description: "Välj systemets språk.",
    },
    room: {
      name: 'Rum',
    },
    back: {
      name: 'Tillbaka till',
    },
    channel: {
      name: 'Kanal',
    },
    cast: {
      title: 'Cast',
      pairing: 'Skanna QR-koden med telefonen för att ansluta till tv:n och casta.',
      pairingNative: 'Öppna Google Cast eller AirPlay på telefonen och välj den här tv:n.',
      pairingNetwork: 'Skanna QR-koden för att ansluta till samma Wi-Fi som tv:n och öppna sedan Google Cast eller AirPlay på telefonen.',
      pairingScreenShare: 'Öppna skärmdelning på telefonen och välj den här tv:n.',
      castEntryHint: 'Blå knapp: öppna skärmdelning på tv:n',
      castSettingsHint: 'Blå knapp: öppna tv:ns Google Cast-inställningar',
      noApps: 'Inga cast-appar är konfigurerade.',
      wifi: 'Wi-Fi',
      password: 'Lösenord',
      unsupported: 'Casting stöds inte på den här tv:n.',
      hotspotStarting: 'Startar WiFi-hotspoten på den här tv:n …',
      hotspotDown: 'WiFi-hotspoten på den här tv:n är inte aktiv just nu. Kontakta personalen.',
      preparing: 'Anslutningen förbereds …',
      waitingForPhone: 'Väntar på att telefonen ansluter …',
      phoneConnected: 'Telefonen ansluten',
      connectTitle: 'Anslut telefonen',
      continueHint: 'När din telefon är ansluten: tryck OK.',
      autoContinue: 'fortsätter om',
      stayHint: 'TILLBAKA: stanna här och visa QR-koden',
      tilesBackHint: 'TILLBAKA: visa QR-koden för att ansluta telefonen',
      castTilesHint: 'Eller från telefonen: öppna appen (YouTube, Prime Video, Disney+ …), tryck på cast-ikonen och välj den här tv:n.',
      clearHint: 'Röd knapp: ta bort dina inloggningsuppgifter från den här tv:n',
      clearTitle: 'Ta bort inloggningsuppgifter',
      clearText: 'Dina inloggningar i apparna på den här tv:n (Netflix, Spotify …) tas bort. Det gäller bara tv:n, inte ditt konto.',
      clearConfirm: 'Ta bort nu',
      clearCancel: 'Avbryt',
      clearBusy: 'Tar bort …',
      clearDone: 'Dina inloggningsuppgifter har tagits bort från den här tv:n.',
      clearRebootText: 'Den här tv:n kan bara ta bort inloggningsuppgifterna vid en omstart. Starta om nu? Det tar ungefär en minut.',
      clearRebootNow: 'Starta om nu',
      clearRebootLater: 'Senare',
      clearLater: 'Inloggningsuppgifterna tas bort nästa gång tv:n stängs av och sätts på igen.',
      clearClose: 'OK',
      launching: '{app} startar …',
      installing: '{app} installeras på den här tv:n …',
      installWait: 'Det kan ta en stund.',
      unavailable: '{app} är för närvarande inte tillgänglig på den här tv:n.',
      installFailed: '{app} kunde inte installeras och är för närvarande inte tillgänglig på den här tv:n.',
      unavailableHint: 'Kontakta receptionen.',
      unavailableKeys: 'OK: andra appar · TILLBAKA: startskärm',
    },
    epg: {
      title: 'Tv-tablå',
      loading: 'Hämtar programdata …',
      noData: 'Ingen programinformation',
      noDescription: 'Ingen ytterligare information.',
      running: 'sänds nu',
      nowOnAir: 'Just nu på den här kanalen',
      hint: 'Piltangenter: navigera · OK: detaljer · GRÖN: tillbaka till nu · TILLBAKA: stäng',
      infoHint: 'VÄNSTER/HÖGER: lista ↔ text · UPP/NED: byt kanal eller rulla · OK: se · TILLBAKA: tablå',
    },
    dateISO: 'sv-SE',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/index.js